<div class="asanaConfirmation">  
    <!-- <mat-dialog-content> -->
        <div class="closeBtn">
            <button class="btn-dialog-close pull-right" mat-stroked-button (click)="onClose(false)" tabIndex="-1">
               &times; <!-- <mat-icon>clear</mat-icon> -->
            </button>
        </div>  
        <div class="md-dialog-content text-center">
            <div>
                <h2 class="confirmTitle" >{{title}}</h2>
                <!-- <div class="fontStyle">Are you sure you want to overwrite the previous version of this report named. <span class="reportName">{{reportName}}</span></div> -->
                <div class="fontStyle" style="white-space: pre-line">{{reportDescription}}<span class="reportName">"{{reportName}}"</span></div>
                <div class="button-wrapper">                    
                    <button class="mono-dark-filled-md-btn-text mr-2" type="button" (click)="onClose(false)">Cancel</button>
                    <button class="accent-filled-md-btn-text" type="button" (click)="onClose(true)">Save</button>
                </div>
            </div>           
        </div>        
    <!-- </mat-dialog-content>   -->
</div>